module.exports = __webpack_public_path__ + "media/images/guideline/coupon-05-20323f9d647587a767ed0656ef2a8829.jpg";